<template>
  <div class="product" :style="{backgroundColor:(change===6?'#fff':'')}">
    <div class="product_content">
      <transition >
        <div class="content_item" v-if="change === 1">
          <div class="change_one">
            <img src="../assets/images/pic_pico01@2x.png">
          </div>
        </div>
      </transition>
      <transition >
      <div class="content_item clearfix" v-if="change === 2">
          <div class="change_two">
              <img src="../assets/images/picopico.png" class="phone_pico">
              <div class="phone_content">
                <img src="../assets/images/PicoPico_content@2x.png" class="title">
                <img src="../assets/images/Group 12@2x.png" class="Group_12">
                <p class="Group_12_text" align="left">各类声线小伙伴治愈你的孤单，大数据会告诉你说啥甜言蜜语受欢迎!<br/>
一点心机小声音，不收获甜甜蜜蜜算我输了!试试吧!也是声控福利频道哦!</p>
                <img src="../assets/images/Group 13@2x.png" class="Group_13">
                <p class="Group_13_text" align="left">乐园入口处设置了匹配雷达，帮你24小时搜索新匹配，海量用户、聊天秒回，还能直接语音连麦，甜甜的停不下来。</p>
                <img src="../assets/images/Group 14@2x.png" class="Group_14">
                <p class="Group_14_text" align="left">几乎所有人都会来的广场！多角度表达释放自己，兴趣、才华、心情，只要留下说说，就会有人来点赞哦！</p>
              </div>
          </div>

      </div>
      </transition>
      <!-- <transition >
        <div class="content_item" v-if="change === 3">
          <div class="change_three">
            <img src="../assets/images/pic_pico03@2x.png" class="Pico_logo">
            <div class="download">
              <img src="../assets/images/pic_pico04@2x.png" class="ios">
              <img src="../assets/images/pic_pico05@2x.png">
            </div>
          </div>
        </div>
      </transition> -->
      <!-- <transition >
        <div class="content_item clearfix" v-if="change === 4">
            <div class="change_four">
              <img src="../assets/images/cct.png" class="phone_kuaishuang">
              <div class="phone_KS_content">
                    <h1 class="titleh1">经营一家自己的串串摊，作为老板的你，除了提供美食之外，就是倾听每个人的所思所想，让匹配的人们在你的串串摊寻求温暖以及心情的释放。</h1>
                    <div class="list nottop">
                      <h2><span></span>遇见 </h2><span ></span>
                       <p class="Group_12_text" align="left">有故事的同龄人</p>
                      </div>
                      <div class="list">
                      <h2><span></span>倾听</h2><span ></span>
                      <p class="Group_12_text" align="left">那些沙雕的、有趣的、感动的、深埋心底的一个个诉说</p>
                       </div>
                      <div class="list">
                      <h2><span></span>回应</h2>
                      <p class="Group_12_text" align="left">慰藉每个有趣的灵幻，让他们得到心情的释放</p>
                       </div>
                     <div class="list">
                      <h2><span></span>经营</h2>
                      <p class="Group_12_text" align="left">积攒人气 打造更有你自己符号的串串摊</p>
                       </div>
                  </div>
            </div>
        </div>
      </transition> -->
       <!-- <transition >
      <div class="content_item clearfix" v-if="change === 5">
          <div class="change_two ">
              <img src="../assets/images/jwla.png" class="phone_pico">
              <div class="phone_content">
                    <h1 class="titleh1">我们虽然是小透明，却有大大的热爱；我的与众不同，只有你能看懂。今晚恋爱，帮你发现多样的同龄人，扩好友、处CP，遇见你想要的甜蜜！</h1>
                    <div class="list">
                      <h2><span></span>匹配六芒星 </h2><span ></span>
                       <p class="Group_12_text" align="left">游戏CP、同城CP、夜晚CP、心动CP…总有一款适合你</p>
                      </div>
                      <div class="list">
                      <h2><span></span>遇见自己人</h2><span ></span>
                      <p class="Group_12_text" align="left">发现同龄人，遇见和你一样内心有热爱的TA</p>
                       </div>
                      <div class="list">
                      <h2><span></span>结交真朋友</h2>
                      <p class="Group_12_text" align="left">一键点击加好友，聊天一键触达</p>
                       </div>
                     
                  </div>
          </div>
      </div>
      </transition> -->
      <img src="../assets/images/icon_RightB@2x.png" class="right" v-if="RightImg" @mouseenter="enter('Right')" @mouseleave="leave('Right')" @click="downward">
      <img src="../assets/images/icon_Right hover@2x.png" class="right" v-else @mouseenter="enter('Right')" @mouseleave="leave('Right')" @click="downward">
      <img src="../assets/images/icon_LeftB@2x.png" class="left" v-if="LeftImg" @mouseenter="enter('left')" @mouseleave="leave('left')" @click="upward">
      <img src="../assets/images/icon_Left hover@2x.png" class="left" v-else @mouseenter="enter('left')" @mouseleave="leave('left')" @click="upward">
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      change: 1,
      RightImg: true,
      LeftImg: true
    }
  },
  methods: {
    downward () {
      if (this.change === 2) {
        this.change = 1
      } else {
        this.change++
      }
    },
    upward () {
      if (this.change === 1) {
        this.change = 2
      } else {
        this.change--
      }
    },
    enter (arg) {
      if (arg === 'Right') {
        this.RightImg = false
      } else {
        this.LeftImg = false
      }
    },
    leave (arg) {
      if (arg === 'Right') {
        this.RightImg = true
      } else {
        this.LeftImg = true
      }
    }
  }
}
</script>
<style lang="less">
    .product{
      min-height: 100vh;
      width: 100%;
      background-color: #FFEF00;
      overflow: hidden;
        padding-bottom: 70px;
      .product_content{
        width: 100%;
        min-height: 100vh;
        min-width: 980px;
        position: relative;
        .content_item{
          width: 100%;
          min-height: 100vh;
          .change_one{
            min-width: 980px;
            max-width: 1200px;
             min-height: 100vh;
            position: relative;
            margin: 0 auto;
            img{
              height: 70%;
              position: absolute;
              top: 70px;
               bottom: 0;
              left: 0;
              right: 0;
              margin: auto;
            }
          }
          .change_two{
            height: 100%;
            min-width: 980px;
            max-width: 1200px;
            margin: 0 auto;
            .phone_pico{
              width: 45%;
              float: left;
              margin-left: 9%;
              margin-top: 15%;
            }
            .phone_content{
              width: 30%;
              height: 85%;
              float: left;
              margin-top: 18%;
              margin-left: -5%;
              .titleh1{
                font-size: 14px;
                font-weight: 500;
              }
              .list{
                margin-top: 27px;
                h2{
                   font-size: 20px;
                font-weight: 600;
                padding-left: 20px;
                ::before{
                  content: '';
                  width: 4px;
                  height: 4px;
                  border-radius: 10px;
                  border: 3px solid #ff477e;
                  display: block;
                  top: 18px;
                  left: -18px;
                  position: relative;
                }
                }
              }
              .title{
                width: 100%;
              }
              .Group_12{
                width:117px;
                margin-top: 27px;
              }
              .Group_12_text{
                font-size: 12px;
                line-height: 22px;
                margin-top: 5px;
                color: #252525;
              }
              .Group_13{
                width: 118px;
                margin-top: 15px;
              }
              .Group_13_text{
                font-size: 12px;
                line-height: 22px;
                margin-top: 5px;
                color: #252525;
              }
              .Group_14{
                width: 118px;
                margin-top: 15px;
              }
              .Group_14_text{
                font-size: 12px;
                line-height: 22px;
                margin-top: 5px;
                color: #252525;
              }
           }

          }
          .change_three{
            height: 100%;
            min-width: 980px;
            max-width: 1200px;
            margin: 0 auto;
            text-align: center;
            .Pico_logo{
              width: 28%;
              margin-top: 10%;
            }
            .download{
              width: 980px;
              margin: 0 auto;
              img{
                width: 30%;
              }
              .ios{
                margin-right: 80px;
              }
            }
            .QQqun{
              // position: absolute;
              float: left;
              margin-top: 80px;
              height: 13px;
            }
          }
          .change_four{
            height: 100%;
            min-width: 980px;
            max-width: 1200px;
            margin: 0 auto;
            .phone_kuaishuang{
              width: 44%;
              float: left;
              margin-left: 12% ;
                  margin-top: 15%;
            }
            .phone_KS_content{
               width: 30%;
               float: left;
               margin-top: 18%;
               margin-left: -5%;
                .titleh1{
                font-size: 14px;
                font-weight: 500;
              }
              
              .list{
              
                h2{
                   font-size: 20px;
                font-weight: 600;
                padding-left: 20px;
                ::before{
                  content: '';
                  width: 4px;
                  height: 4px;
                  border-radius: 10px;
                  border: 3px solid #ff477e;
                  display: block;
                  top: 18px;
                  left: -18px;
                  position: relative;
                }
                }
              }
              .nottop{
                margin-top: 20px;
              }
               .title{
                 width: 30%;
               }
               .KS_content{
                 width: 100%;
                 margin-top: 20px;
               }
               .plot{
                 margin-top: 10px;
                 .plot_item{
                   height: 18px;
                   margin-top: 30px;
                   img{
                     height:100%;
                     vertical-align: middle;
                   }
                   span{
                     display: inline-block;
                     font-size: 14px;
                     margin-left: 10px;
                     line-height: 18px;
                   }
                 }
               }
            }
          }
          .change_five{
            height: 100%;
            min-width: 980px;
            max-width: 1200px;
            margin: 0 auto;
            .phone_chuan{
              width: 30%;
              float: left;
              margin: 15% 0 0 18%;
            }
            .phone_SS_content{
               width: 28%;
               float: left;
               margin-top: 18%;
               margin-left: 5%;
               .title{
                 width: 30%;
               }
               .KS_content{
                 width: 100%;
                 margin-top: 20px;
               }
               .plot{
                 margin-top: 10px;
                 .plot_item{
                   height: 20px;
                   margin-top: 30px;
                   img{
                     height:100%;
                     vertical-align:middle;
                   }
                   span{
                     font-size: 12px;
                     white-space:nowrap;
                     margin-top: 4px;
                     display: block;
                   }
                 }
               }
            }
          }
        }
        .left{
          position: absolute;
          top: 45%;
          left: 10%;
          width: 60px;
        }
        .right{
          position: absolute;
          top: 45%;
          right: 10%;
          width: 60px;
        }
      }
  }

.v-enter-active{
  transition: opacity 2s
}
.v-enter{
  opacity: 0;
}
.v-enter-to{
  opacity: 1;
}

</style>



// WEBPACK FOOTER //
// src/components/product.vue